import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import MCQViewer from "./MCQViewer";
import TrueFalseViewer from "./TrueFalseViewer";
import MatchViewer from "./MatchViewer";
import FillUpsViewer from "./FillUpsViewer";
import AnalysisComponent from "./AnalysisComponent";
import MDEditor from "@uiw/react-md-editor";
import Switch from "@mui/material/Switch";
import {
  GENERATE_CONTENT_URL,
  GENERATE_CONTENT_NEW_FORMAT_URL,
  GENERATE_CONTENT_TEACHER_URL,
} from "../../helper/apiurls/apiurls";
import {
  createQuestionBank,
  updateQuestionBank,
  getQuestionBankById,
  createInstitutionQuestionBank,
  updateInstitutionQuestionBank,
} from "../../helper/apicalls/questionBank";
import { insertContentWithSequenceManagement } from "./contentSequenceUtils";
import "../../styles/common/generateQuestionBankPopup.scss";
import Cookies from "js-cookie";

const GenerateQuestionBankPopup = ({
  open,
  handleClose,
  onSave,
  initialData,
  context,
  contextKey,
  folderId,
  addNext,
  bankId,
  existingContent,
  insertIndex,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [name, setName] = useState("");
  const [duration, setDuration] = useState("");
  const [prompt, setPrompt] = useState("");
  const [manualMCQContent, setManualMCQContent] = useState({
    questions: [
      {
        question: "",
        options: ["", "", "", ""],
        correctIndex: 0,
        explanation: "",
      },
    ],
  });
  const [manualTrueFalseContent, setManualTrueFalseContent] = useState({
    questions: [
      {
        question: "",
        answer: "true",
        explanation: "",
      },
    ],
  });

  const [manualMatchContent, setManualMatchContent] = useState({
    pairs: [
      {
        left: "",
        right: "",
      },
    ],
  });

  const [manualFillUpsContent, setManualFillUpsContent] = useState({
    sentences: [
      {
        sentence: "",
        answers: [""],
      },
    ],
  });

  const [manualAnalysisContent, setManualAnalysisContent] = useState({
    title: "",
    content: "",
  });
  const [generatedQuestions, setGeneratedQuestions] = useState(null);
  const [questionType, setQuestionType] = useState("mcq");
  const [category, setCategory] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [websocketStatus, setWebsocketStatus] = useState("");
  const [generateError, setGenerateError] = useState("");
  const websocketRef = useRef(null);
  const [publish, setPublish] = useState(false);
  const [testQuestionCounts, setTestQuestionCounts] = useState({});
  const token = Cookies.get("institution_token") || Cookies.get("admin_token") || "";
  const location = useLocation();
  const isInstitution = location.pathname.startsWith("/institution") || location.pathname.startsWith("/teacher");

  const normalizeAnswer = (answer) => {
    if (typeof answer === "boolean") {
      return answer ? "true" : "false";
    }
    if (typeof answer === "string") {
      const lowerAnswer = answer.toLowerCase();
      if (
        lowerAnswer === "true" ||
        lowerAnswer === "1" ||
        lowerAnswer === "a" ||
        lowerAnswer === "yes"
      ) {
        return "true";
      }
      if (
        lowerAnswer === "false" ||
        lowerAnswer === "0" ||
        lowerAnswer === "b" ||
        lowerAnswer === "no"
      ) {
        return "false";
      }
    }
    return answer;
  };

  const testQuestionTypes = [
    { key: "mcq", label: "MCQ" },
    { key: "trueorfalse", label: "True or False" },
    { key: "match", label: "Match" },
    { key: "fillups", label: "Fill Ups" },
    // { key: "analysis", label: "Analysis" },
  ];

  const [testSwitchState, setTestSwitchState] = useState(
    testQuestionTypes.reduce((acc, item) => {
      acc[item.key] = false;
      return acc;
    }, {})
  );

  useEffect(() => {
    if (open) {
      setActiveTab(0);
      setPrompt("");
      setQuestionType("mcq");
      setCategory("");
      setGenerateError("");
      setIsGenerating(false);
      setWebsocketStatus("");
      setPublish(false);
      setGeneratedQuestions(null);
      setTestSwitchState(
        testQuestionTypes.reduce((acc, item) => {
          acc[item.key] = false;
          return acc;
        }, {})
      );
      setTestQuestionCounts({});
      setManualMCQContent({
        questions: [
          {
            question: "",
            options: ["", "", "", ""],
            correctIndex: 0,
            explanation: "",
          },
        ],
      });
      setManualTrueFalseContent({
        questions: [
          {
            question: "",
            answer: "true",
            explanation: "",
          },
        ],
      });
      setManualMatchContent({
        pairs: [
          {
            left: "",
            right: "",
          },
        ],
      });
      setManualFillUpsContent({
        sentences: [
          {
            sentence: "",
            answers: [""],
          },
        ],
      });
      setManualAnalysisContent({
        title: "",
        content: "",
      });
      if (initialData) {
        setName(initialData.name || "");
        setDuration(
          initialData.duration !== undefined && initialData.duration !== null
            ? String(initialData.duration)
            : ""
        );
        if (typeof initialData.publish === "boolean") {
          setPublish(initialData.publish);
        }
        if (initialData.category) {
          setCategory(initialData.category);
        }
      } else {
        setName("");
        setDuration("");
      }
    }
  }, [open, initialData]);

  useEffect(() => {
    if (!open) return;
    if (activeTab === 1) {
      if (questionType === "mcq") {
        setManualMCQContent((prev) =>
          prev && prev.questions && prev.questions.length
            ? prev
            : {
                questions: [
                  {
                    question: "",
                    options: ["", "", "", ""],
                    correctIndex: 0,
                    explanation: "",
                  },
                ],
              }
        );
      } else if (questionType === "trueorfalse") {
        setManualTrueFalseContent((prev) =>
          prev && prev.questions && prev.questions.length
            ? prev
            : {
                questions: [
                  {
                    question: "",
                    answer: "true",
                    explanation: "",
                  },
                ],
              }
        );
      } else if (questionType === "match") {
        setManualMatchContent((prev) =>
          prev && prev.pairs && prev.pairs.length
            ? prev
            : {
                pairs: [
                  {
                    left: "",
                    right: "",
                  },
                ],
              }
        );
      } else if (questionType === "fillups") {
        setManualFillUpsContent((prev) =>
          prev && prev.sentences && prev.sentences.length
            ? prev
            : {
                sentences: [
                  {
                    sentence: "",
                    answers: [""],
                  },
                ],
              }
        );
      } else if (questionType === "analysis") {
        setManualAnalysisContent((prev) =>
          prev && (prev.title || prev.content)
            ? prev
            : {
                title: "",
                content: "",
              }
        );
      }
    }
  }, [questionType, activeTab, open]);

  if (!open) return null;

  const formatManualQuestionsForSave = () => {
    switch (questionType) {
      case "mcq": {
        const formattedMCQ = {
          questions: (manualMCQContent.questions || []).map((q) => {
            const options = (q.options || []).map((option, index) => {
              const label = String.fromCharCode(65 + index);
              return { [label]: option };
            });
            const correctLabel = String.fromCharCode(
              65 + (q.correctIndex || 0)
            );
            return {
              question: q.question || "",
              options,
              answer: correctLabel,
              explanation: q.explanation || "",
            };
          }),
        };
        return formattedMCQ;
      }

      case "trueorfalse": {
        const formattedTF = {
          questions: (manualTrueFalseContent.questions || []).map((q) => ({
            question: q.question || "",
            answer: q.answer || "true",
            explanation: q.explanation || "",
          })),
        };
        return formattedTF;
      }

      case "match": {
        const pairs = manualMatchContent.pairs || [];
        const leftValues = pairs.map((p) => p.left || "");
        const rightValues = pairs.map((p) => p.right || "");
        const formattedMatch = {
          questions: [
            { key: "Column 1", values: leftValues },
            { key: "Column 2", values: rightValues },
          ],
        };
        return formattedMatch;
      }

      case "fillups": {
        const formattedFillUps = {
          questions: (manualFillUpsContent.sentences || []).map((s) => ({
            question: s.sentence || "",
            answer:
              (Array.isArray(s.answers) && s.answers.length > 0
                ? s.answers[0]
                : "") || "",
          })),
        };
        return formattedFillUps;
      }

      case "analysis": {
        const formattedAnalysis = {
          questions: [
            {
              question: manualAnalysisContent.title || "",
              explanation: manualAnalysisContent.content || "",
            },
          ],
        };
        return formattedAnalysis;
      }

      default:
        return {};
    }
  };

  const handleSaveClick = async () => {
    const mode = activeTab === 0 ? "ai" : "manual";
    const trimmedName = name?.trim() || "";
    const questions =
      activeTab === 0 ? generatedQuestions : formatManualQuestionsForSave();

    let newQuestionItems = [];
    if (activeTab === 0) {
      if (Array.isArray(generatedQuestions)) {
        newQuestionItems = generatedQuestions;
      } else if (
        generatedQuestions &&
        typeof generatedQuestions === "object" &&
        Array.isArray(generatedQuestions.questions)
      ) {
        newQuestionItems = generatedQuestions.questions;
      } else if (generatedQuestions) {
        newQuestionItems = [generatedQuestions];
      }
    } else {
      if (questions && Array.isArray(questions.questions)) {
        newQuestionItems = questions.questions;
      }
    }

    newQuestionItems = newQuestionItems.map((q) => ({
      ...q,
      type: q.type || questionType,
      categories: q.categories || category || "",
    }));

    try {
      let finalContentArray;

      const createFn = isInstitution
        ? createInstitutionQuestionBank
        : createQuestionBank;
      const updateFn = isInstitution
        ? updateInstitutionQuestionBank
        : updateQuestionBank;

      if (addNext && bankId) {
        const baseArray = Array.isArray(existingContent) ? existingContent : [];

        finalContentArray = newQuestionItems.reduce((acc, item) => {
          return insertContentWithSequenceManagement(acc, item, insertIndex);
        }, baseArray);
        await updateFn({
          id: bankId,
          name: trimmedName,
          duration: duration?.trim() || "",
          publish,
          content: finalContentArray,
        });
        try {
          const refreshed = await getQuestionBankById(bankId);
          if (onSave && refreshed) {
            onSave(refreshed);
          }
        } catch (fetchErr) {
          console.error(
            "Failed to refetch question bank after update:",
            fetchErr
          );
        }
      } else {
        finalContentArray = newQuestionItems.map((q, index) => ({
          ...q,
          sequence: q.sequence !== undefined ? q.sequence : index + 1,
        }));

        await createFn(trimmedName, publish, finalContentArray, folderId);
      }

      if (onSave && !(addNext && bankId)) {
        onSave({
          name: trimmedName,
          publish,
          content: finalContentArray,
          mode,
          duration: duration?.trim() || "",
          prompt: activeTab === 0 ? prompt : "",
          type: questionType,
          category: category || "",
        });
      }

      if (handleClose) handleClose();
    } catch (err) {}
  };

  const handleGenerateClick = () => {
    if (!prompt.trim()) {
      setGenerateError("Please enter a prompt");
      return;
    }

    setIsGenerating(true);
    setWebsocketStatus("processing");
    setGenerateError("");

    try {
      if (websocketRef.current) {
        websocketRef.current.close();
      }

      let socketUrl = GENERATE_CONTENT_URL;
      const isQuestionBank = true;
      if (isQuestionBank) {
        const role = Cookies.get("role");
        if (role === "institution" || role === "teacher") {
          socketUrl = GENERATE_CONTENT_TEACHER_URL;
        } else {
          socketUrl = GENERATE_CONTENT_NEW_FORMAT_URL;
        }
      }

      websocketRef.current = new WebSocket(socketUrl);

      websocketRef.current.onopen = () => {
        const fieldToSend = context || "questionbank";
        const keyToSend = contextKey || "";

        const typesArr = [];
        testQuestionTypes.forEach((item) => {
          const enabled = testSwitchState[item.key];
          const countNum = Number(testQuestionCounts[item.key] || 0);
          if (enabled && Number.isFinite(countNum) && countNum > 0) {
            typesArr.push({ type: item.key, count: countNum });
          }
        });

        if (typesArr.length === 0) {
          typesArr.push({ type: questionType || "mcq", count: 1 });
        }

        const message = {
          prompt: prompt.trim(),
          types: typesArr,
          field: fieldToSend,
          key: keyToSend,
          token: token,
        };

        websocketRef.current.send(JSON.stringify(message));
      };

      websocketRef.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data?.status) {
            setWebsocketStatus(data.status);
          }

          if (Array.isArray(data?.results)) {
            setWebsocketStatus("completed");
            const results = data.results;

            const flattenedQuestions = [];
            results.forEach((r) => {
              const structured = r?.data?.structured;
              const questions = structured?.questions;
              if (Array.isArray(questions) && questions.length > 0) {
                questions.forEach((q) => {
                  flattenedQuestions.push(q);
                });
              }
            });

            if (flattenedQuestions.length > 0) {
              setGeneratedQuestions(flattenedQuestions);
              setIsGenerating(false);
              return;
            }

            setGeneratedQuestions(data);
            setIsGenerating(false);
            return;
          }

          if (data && data.status === "completed" && data.data) {
            setWebsocketStatus("completed");
            let contentToSet = data.data.content ?? data.data;

            if (typeof contentToSet === "string") {
              try {
                contentToSet = JSON.parse(contentToSet);
              } catch (parseError) {}
            }

            setGeneratedQuestions(contentToSet);
          } else if (data && data.status === "processing") {
            setIsGenerating(true);
            return;
          } else if (data && data.data) {
            let contentToSet = data.data.content ?? data.data;

            if (typeof contentToSet === "string") {
              try {
                contentToSet = JSON.parse(contentToSet);
              } catch (parseError) {}
            }

            setGeneratedQuestions(contentToSet);
          } else {
            let contentToSet = event.data;
            if (typeof contentToSet === "string") {
              try {
                contentToSet = JSON.parse(contentToSet);
              } catch (parseError) {}
            }
            setGeneratedQuestions(contentToSet);
          }
        } catch (err) {
          let contentToSet = event.data;
          if (typeof contentToSet === "string") {
            try {
              contentToSet = JSON.parse(contentToSet);
            } catch (parseError) {}
          }
          setGeneratedQuestions(contentToSet);
        } finally {
          setIsGenerating(false);
        }
      };

      websocketRef.current.onerror = () => {
        setGenerateError("Failed to connect to generator service");
        setIsGenerating(false);
        setWebsocketStatus("error");
      };

      websocketRef.current.onclose = () => {
        setIsGenerating(false);
        setWebsocketStatus((prev) => (prev === "completed" ? "completed" : ""));
      };
    } catch (err) {
      setGenerateError("Failed to start generation");
      setIsGenerating(false);
      setWebsocketStatus("error");
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && handleClose) {
      handleClose();
    }
  };

  return (
    <div
      className="qb-generator-popup high-z-index"
      onClick={handleBackdropClick}
    >
      <div className="qb-generator-dialog">
        <div className="qb-generator-header">
          <h2 className="qb-generator-title">Generate Question Bank</h2>
          <button className="qb-generator-close" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="qb-generator-tabs">
          <div
            className={`qb-generator-tab ${activeTab === 0 ? "active" : ""}`}
            onClick={() => setActiveTab(0)}
          >
            Generate with AI
          </div>
          <div
            className={`qb-generator-tab ${activeTab === 1 ? "active" : ""}`}
            onClick={() => {
              setActiveTab(1);
            }}
          >
            Manual
          </div>
        </div>

        <div className="qb-generator-row">
          <div className="qb-generator-field">
            <label className="qb-generator-label">Name</label>
            <input
              type="text"
              className="qb-generator-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter question bank name"
            />
          </div>

          <div className="qb-generator-field">
            <label className="qb-generator-label">Duration</label>
            <input
              type="text"
              className="qb-generator-input"
              value={duration}
              onChange={(e) => setDuration(e.target.value)}
              placeholder="Enter duration (e.g. 30 mins)"
            />
          </div>

          <div className="qb-generator-field qb-generator-switch">
            <label className="qb-generator-label">Publish</label>
            <Switch
              size="small"
              checked={publish}
              onChange={(e) => setPublish(e.target.checked)}
            />
          </div>
        </div>

        <div className="qb-generator-content">
          {activeTab === 0 ? (
            <div className="qb-generator-tab-content active">
              <div className="input-section">
                <div className="prompt-section">
                  <textarea
                    className="prompt-textarea"
                    placeholder="Enter a prompt to generate questions for this bank"
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                  />
                </div>
                <div className="qb-question-types">
                  <div className="qb-question-types-label qb-generator-label">
                    Question Types & Count
                  </div>
                  {testQuestionTypes.map((item) => (
                    <div key={item.key} className="qb-question-type-row">
                      <div className="qb-question-type-name">{item.label}</div>
                      <Switch
                        size="small"
                        checked={!!testSwitchState[item.key]}
                        onChange={() =>
                          setTestSwitchState((prev) => ({
                            ...prev,
                            [item.key]: !prev[item.key],
                          }))
                        }
                      />
                      <input
                        type="number"
                        min="1"
                        className={`qb-question-type-count-input ${
                          testSwitchState[item.key] ? "visible" : "hidden"
                        }`}
                        placeholder="No.of Count"
                        value={(testQuestionCounts[item.key] ?? "").toString()}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          setTestQuestionCounts((prev) => ({
                            ...prev,
                            [item.key]: value,
                          }));
                        }}
                      />
                    </div>
                  ))}
                </div>
                {websocketStatus === "completed" && generatedQuestions && (
                  <div className="preview-section">
                    {Array.isArray(generatedQuestions) ? (
                      generatedQuestions.map((item, index) => {
                        let itemType = item?.type || questionType;
                        const itemContent = item;

                        switch (itemType) {
                          case "mcq":
                            return (
                              <MCQViewer
                                key={`mcq-${index}`}
                                questionData={itemContent}
                                onUpdate={setGeneratedQuestions}
                                allowEditWithoutPersist={true}
                                title="Generated MCQ Question Bank"
                              />
                            );
                          case "trueorfalse":
                            return (
                              <TrueFalseViewer
                                key={`tf-${index}`}
                                questionData={itemContent}
                                onUpdate={setGeneratedQuestions}
                                allowEditWithoutPersist={true}
                                title="Generated True/False Question Bank"
                              />
                            );
                          case "match":
                            return (
                              <MatchViewer
                                key={`match-${index}`}
                                questionData={itemContent}
                                onUpdate={setGeneratedQuestions}
                                title="Generated Match Question Bank"
                              />
                            );
                          case "fillups":
                            return (
                              <FillUpsViewer
                                key={`fillups-${index}`}
                                questionData={itemContent}
                                onUpdate={setGeneratedQuestions}
                                title="Generated Fill Ups Question Bank"
                              />
                            );
                          case "analysis":
                            return (
                              <AnalysisComponent
                                key={`analysis-${index}`}
                                data={itemContent}
                                onUpdate={setGeneratedQuestions}
                                title="Generated Analysis Question Bank"
                              />
                            );
                          default:
                            return null;
                        }
                      })
                    ) : questionType === "mcq" ? (
                      <MCQViewer
                        questionData={generatedQuestions}
                        onUpdate={setGeneratedQuestions}
                        allowEditWithoutPersist={true}
                        title="Generated MCQ Question Bank"
                      />
                    ) : questionType === "trueorfalse" ? (
                      <TrueFalseViewer
                        questionData={generatedQuestions}
                        onUpdate={setGeneratedQuestions}
                        allowEditWithoutPersist={true}
                        title="Generated True/False Question Bank"
                      />
                    ) : questionType === "match" ? (
                      <MatchViewer
                        questionData={generatedQuestions}
                        onUpdate={setGeneratedQuestions}
                        title="Generated Match Question Bank"
                      />
                    ) : questionType === "fillups" ? (
                      <FillUpsViewer
                        questionData={generatedQuestions}
                        onUpdate={setGeneratedQuestions}
                        title="Generated Fill Ups Question Bank"
                      />
                    ) : (
                      <AnalysisComponent
                        data={generatedQuestions}
                        onUpdate={setGeneratedQuestions}
                        title="Generated Analysis Question Bank"
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="qb-generator-tab-content active">
              <div className="input-section">
                {questionType === "mcq" && (
                  <div className="manual-mcq-content">
                    <h3 className="mcq-title">MCQ Questions</h3>
                    {manualMCQContent.questions.map((q, index) => (
                      <div key={index} className="mcq-question">
                        <input
                          className="question-input"
                          placeholder={`Question ${index + 1}`}
                          value={q.question || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            setManualMCQContent((prev) => ({
                              ...prev,
                              questions: prev.questions.map((qq, i) =>
                                i === index ? { ...qq, question: val } : qq
                              ),
                            }));
                          }}
                        />
                        {(q.options || []).map((option, optIndex) => {
                          let optionText = "";
                          if (typeof option === "object" && option !== null) {
                            if (Object.keys(option).length === 1) {
                              const firstValue = Object.values(option)[0];
                              optionText =
                                typeof firstValue === "string"
                                  ? firstValue
                                  : JSON.stringify(firstValue);
                            } else {
                              optionText =
                                option.text ||
                                option.option ||
                                option.value ||
                                option.answer ||
                                JSON.stringify(option);
                            }
                          } else {
                            optionText = option;
                          }
                          return (
                            <div key={optIndex} className="option-row">
                              <input
                                type="radio"
                                className="option-radio"
                                checked={q.correctIndex === optIndex}
                                onChange={() => {
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.map((qq, i) =>
                                      i === index
                                        ? { ...qq, correctIndex: optIndex }
                                        : qq
                                    ),
                                  }));
                                }}
                              />
                              <input
                                className="option-input"
                                placeholder={`Option ${String.fromCharCode(
                                  65 + optIndex
                                )}`}
                                value={optionText}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.map((qq, i) => {
                                      if (i !== index) return qq;
                                      const opts = [...(qq.options || [])];
                                      opts[optIndex] = val;
                                      return { ...qq, options: opts };
                                    }),
                                  }));
                                }}
                              />
                              <button
                                className="option-delete-btn"
                                onClick={() => {
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.map((qq, i) => {
                                      if (i !== index) return qq;
                                      const opts = (qq.options || []).filter(
                                        (_, oi) => oi !== optIndex
                                      );
                                      let newCorrectIndex = qq.correctIndex;
                                      if (optIndex < qq.correctIndex) {
                                        newCorrectIndex = Math.max(
                                          0,
                                          qq.correctIndex - 1
                                        );
                                      } else if (optIndex === qq.correctIndex) {
                                        newCorrectIndex = Math.min(
                                          opts.length - 1,
                                          qq.correctIndex
                                        );
                                      }
                                      return {
                                        ...qq,
                                        options: opts,
                                        correctIndex: newCorrectIndex,
                                      };
                                    }),
                                  }));
                                }}
                              >
                                ×
                              </button>
                            </div>
                          );
                        })}
                        <button
                          className="add-option-btn"
                          onClick={() => {
                            setManualMCQContent((prev) => ({
                              ...prev,
                              questions: prev.questions.map((qq, i) =>
                                i === index
                                  ? {
                                      ...qq,
                                      options: [...(qq.options || []), ""],
                                    }
                                  : qq
                              ),
                            }));
                          }}
                        >
                          + Add Option
                        </button>
                        <textarea
                          className="explanation-textarea"
                          placeholder="Explanation"
                          value={q.explanation || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            setManualMCQContent((prev) => ({
                              ...prev,
                              questions: prev.questions.map((qq, i) =>
                                i === index ? { ...qq, explanation: val } : qq
                              ),
                            }));
                          }}
                        />
                        {manualMCQContent.questions.length > 1 && (
                          <div style={{ marginTop: 16 }}>
                            <button
                              className="remove-question-btn"
                              onClick={() => {
                                if (manualMCQContent.questions.length > 1) {
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.filter(
                                      (_, i) => i !== index
                                    ),
                                  }));
                                }
                              }}
                            >
                              Remove Question
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                    <button
                      className="add-question-btn"
                      onClick={() => {
                        setManualMCQContent((prev) => ({
                          ...prev,
                          questions: [
                            ...prev.questions,
                            {
                              question: "",
                              options: ["", "", "", ""],
                              correctIndex: 0,
                              explanation: "",
                            },
                          ],
                        }));
                      }}
                    >
                      + Add Question
                    </button>
                  </div>
                )}
                {questionType === "trueorfalse" && (
                  <div className="manual-truefalse-content">
                    <h3 className="tf-title">True/False Questions</h3>
                    {manualTrueFalseContent.questions.map((q, index) => {
                      const correctAnswer = normalizeAnswer(
                        q.answer || q.correct_answer || q.correct || "true"
                      );
                      const normalizedCorrectAnswer =
                        normalizeAnswer(correctAnswer);

                      return (
                        <div key={index} className="tf-question">
                          <input
                            className="question-input"
                            placeholder={`Question ${index + 1}`}
                            value={q.question || q.title || q.text || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setManualTrueFalseContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index ? { ...qq, question: val } : qq
                                ),
                              }));
                            }}
                          />
                          <div className="tf-answer">
                            <div
                              className={`tf-option ${
                                normalizedCorrectAnswer === "true"
                                  ? "correct"
                                  : ""
                              }`}
                              onClick={() => {
                                setManualTrueFalseContent((prev) => ({
                                  ...prev,
                                  questions: prev.questions.map((qq, i) =>
                                    i === index
                                      ? {
                                          ...qq,
                                          answer: "true",
                                          correct_answer: "true",
                                        }
                                      : qq
                                  ),
                                }));
                              }}
                            >
                              <input
                                type="radio"
                                className="tf-radio"
                                checked={normalizedCorrectAnswer === "true"}
                                onChange={() => {}}
                              />
                              <span>True</span>
                            </div>
                            <div
                              className={`tf-option ${
                                normalizedCorrectAnswer === "false"
                                  ? "correct"
                                  : ""
                              }`}
                              onClick={() => {
                                setManualTrueFalseContent((prev) => ({
                                  ...prev,
                                  questions: prev.questions.map((qq, i) =>
                                    i === index
                                      ? {
                                          ...qq,
                                          answer: "false",
                                          correct_answer: "false",
                                        }
                                      : qq
                                  ),
                                }));
                              }}
                            >
                              <input
                                type="radio"
                                className="tf-radio"
                                checked={normalizedCorrectAnswer === "false"}
                                onChange={() => {}}
                              />
                              <span>False</span>
                            </div>
                          </div>
                          <textarea
                            className="explanation-textarea"
                            placeholder="Explanation"
                            value={q.explanation || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setManualTrueFalseContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index ? { ...qq, explanation: val } : qq
                                ),
                              }));
                            }}
                          />
                          {manualTrueFalseContent.questions.length > 1 && (
                            <div style={{ marginTop: 16 }}>
                              <button
                                className="remove-question-btn"
                                onClick={() => {
                                  if (
                                    manualTrueFalseContent.questions.length > 1
                                  ) {
                                    setManualTrueFalseContent((prev) => ({
                                      ...prev,
                                      questions: prev.questions.filter(
                                        (_, i) => i !== index
                                      ),
                                    }));
                                  }
                                }}
                              >
                                Remove Question
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                    <button
                      className="add-question-btn"
                      onClick={() => {
                        setManualTrueFalseContent((prev) => ({
                          ...prev,
                          questions: [
                            ...prev.questions,
                            {
                              question: "",
                              answer: "true",
                              explanation: "",
                            },
                          ],
                        }));
                      }}
                    >
                      + Add Question
                    </button>
                  </div>
                )}
                {questionType === "match" && (
                  <div className="manual-match-content">
                    <h3 className="match-title">Match Pairs</h3>
                    {manualMatchContent.pairs.map((pair, index) => (
                      <div key={index} className="match-pair">
                        <input
                          className="match-left-input"
                          placeholder="Left side"
                          value={pair.left}
                          onChange={(e) =>
                            setManualMatchContent((prev) => ({
                              ...prev,
                              pairs: prev.pairs.map((p, i) =>
                                i === index ? { ...p, left: e.target.value } : p
                              ),
                            }))
                          }
                        />
                        <input
                          className="match-right-input"
                          placeholder="Right side"
                          value={pair.right}
                          onChange={(e) =>
                            setManualMatchContent((prev) => ({
                              ...prev,
                              pairs: prev.pairs.map((p, i) =>
                                i === index
                                  ? { ...p, right: e.target.value }
                                  : p
                              ),
                            }))
                          }
                        />
                        {manualMatchContent.pairs.length > 1 && (
                          <button
                            className="remove-pair-btn"
                            onClick={() => {
                              if (manualMatchContent.pairs.length > 1) {
                                setManualMatchContent((prev) => ({
                                  ...prev,
                                  pairs: prev.pairs.filter(
                                    (_, i) => i !== index
                                  ),
                                }));
                              }
                            }}
                          >
                            Remove Pair
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      className="add-pair-btn"
                      onClick={() => {
                        setManualMatchContent((prev) => ({
                          ...prev,
                          pairs: [
                            ...prev.pairs,
                            {
                              left: "",
                              right: "",
                            },
                          ],
                        }));
                      }}
                    >
                      + Add Pair
                    </button>
                  </div>
                )}
                {questionType === "fillups" && (
                  <div className="manual-fillups-content">
                    <h3 className="fillups-title">Fill in the Blanks</h3>
                    {manualFillUpsContent.sentences.map((sentence, index) => (
                      <div key={index} className="fillups-sentence">
                        <textarea
                          className="sentence-textarea"
                          placeholder="Sentence with blanks represented by underscores, e.g., 'The capital of France is ____.'"
                          value={sentence.sentence}
                          onChange={(e) =>
                            setManualFillUpsContent((prev) => ({
                              ...prev,
                              sentences: prev.sentences.map((s, i) =>
                                i === index
                                  ? { ...s, sentence: e.target.value }
                                  : s
                              ),
                            }))
                          }
                        />
                        <div className="answers-section">
                          <h4>Answers:</h4>
                          {sentence.answers.map((answer, ansIndex) => (
                            <div key={ansIndex} className="answer-input">
                              <input
                                type="text"
                                placeholder={`Answer ${ansIndex + 1}`}
                                value={answer}
                                onChange={(e) =>
                                  setManualFillUpsContent((prev) => ({
                                    ...prev,
                                    sentences: prev.sentences.map((s, i) =>
                                      i === index
                                        ? {
                                            ...s,
                                            answers: s.answers.map((a, j) =>
                                              j === ansIndex
                                                ? e.target.value
                                                : a
                                            ),
                                          }
                                        : s
                                    ),
                                  }))
                                }
                              />
                              {sentence.answers.length > 1 && (
                                <button
                                  className="remove-answer-btn"
                                  onClick={() => {
                                    if (sentence.answers.length > 1) {
                                      setManualFillUpsContent((prev) => ({
                                        ...prev,
                                        sentences: prev.sentences.map((s, i) =>
                                          i === index
                                            ? {
                                                ...s,
                                                answers: s.answers.filter(
                                                  (_, j) => j !== ansIndex
                                                ),
                                              }
                                            : s
                                        ),
                                      }));
                                    }
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          ))}
                          <button
                            className="add-answer-btn"
                            onClick={() =>
                              setManualFillUpsContent((prev) => ({
                                ...prev,
                                sentences: prev.sentences.map((s, i) =>
                                  i === index
                                    ? {
                                        ...s,
                                        answers: [...s.answers, ""],
                                      }
                                    : s
                                ),
                              }))
                            }
                          >
                            + Add Answer
                          </button>
                        </div>
                        {manualFillUpsContent.sentences.length > 1 && (
                          <button
                            className="remove-sentence-btn"
                            onClick={() => {
                              if (manualFillUpsContent.sentences.length > 1) {
                                setManualFillUpsContent((prev) => ({
                                  ...prev,
                                  sentences: prev.sentences.filter(
                                    (_, i) => i !== index
                                  ),
                                }));
                              }
                            }}
                          >
                            Remove Sentence
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      className="add-sentence-btn"
                      onClick={() =>
                        setManualFillUpsContent((prev) => ({
                          ...prev,
                          sentences: [
                            ...prev.sentences,
                            { sentence: "", answers: [""] },
                          ],
                        }))
                      }
                    >
                      + Add Sentence
                    </button>
                  </div>
                )}
                {questionType === "analysis" && (
                  <div className="manual-analysis-content">
                    <h3 className="analysis-title">Analysis Content</h3>
                    <input
                      className="analysis-title-input"
                      placeholder="Analysis Title"
                      value={manualAnalysisContent.title}
                      onChange={(e) =>
                        setManualAnalysisContent((prev) => ({
                          ...prev,
                          title: e.target.value,
                        }))
                      }
                    />
                    <MDEditor
                      value={manualAnalysisContent.content}
                      onChange={(value) =>
                        setManualAnalysisContent((prev) => ({
                          ...prev,
                          content: value || "",
                        }))
                      }
                      preview="live"
                      height={300}
                    />
                  </div>
                )}
              </div>
              <div className="preview-section">
                <h3 className="preview-title">Question Bank Preview</h3>
                <div className="content-preview">
                  {questionType === "mcq" ? (
                    <MCQViewer
                      questionData={formatManualQuestionsForSave()}
                      title="Manual MCQ Question Bank Preview"
                    />
                  ) : questionType === "trueorfalse" ? (
                    <TrueFalseViewer
                      questionData={formatManualQuestionsForSave()}
                      title="Manual True/False Question Bank Preview"
                    />
                  ) : questionType === "match" ? (
                    <MatchViewer
                      questionData={formatManualQuestionsForSave()}
                      title="Manual Match Question Bank Preview"
                    />
                  ) : questionType === "fillups" ? (
                    <FillUpsViewer
                      questionData={formatManualQuestionsForSave()}
                      title="Manual Fill Ups Question Bank Preview"
                    />
                  ) : questionType === "analysis" ? (
                    <AnalysisComponent
                      data={formatManualQuestionsForSave()}
                      title="Manual Analysis Question Bank Preview"
                    />
                  ) : null}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="qb-generator-actions">
          {activeTab === 0 && (
            <button
              className="qb-action-btn primary"
              type="button"
              onClick={handleGenerateClick}
              disabled={websocketStatus === "processing" || isGenerating}
            >
              {websocketStatus === "processing" || isGenerating ? "Generating..." : "Generate"}
            </button>
          )}
          <button
            className={`qb-action-btn primary ${
              activeTab === 0 && (websocketStatus !== "completed" || !generatedQuestions)
                ? "qb-action-btn-disabled"
                : ""
            }`}
            type="button"
            disabled={activeTab === 0 && (websocketStatus !== "completed" || !generatedQuestions)}
            onClick={handleSaveClick}
            style={
              activeTab === 0 && (websocketStatus !== "completed" || !generatedQuestions)
                ? { opacity: 0.6, cursor: "not-allowed" }
                : {}
            }
          >
            Save Question Bank
          </button>
          {/* <button className="qb-action-btn" type="button" onClick={handleClose}>
            Cancel
          </button> */}
        </div>
        {generateError && (
          <div className="qb-generator-error">{generateError}</div>
        )}
      </div>
    </div>
  );
};

export default GenerateQuestionBankPopup;
